module.exports = __webpack_public_path__ + "static/img/product_banner_01_zh.db5c11b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_01_zh.png
// module id = MAAw
// module chunks = 34